// extracted by mini-css-extract-plugin
export default {"wrapper":"krxwbpHFxNOaaCL2uPa2","freezeBtn":"uXuY6anMtqw7VjH4WOAo"};